import { createSignal } from 'solid-js';
import { gameStore } from '@/stores/gameStore';
import { useTranslation } from '@/i18n';
import './AdminLogin.css';

export default function AdminLogin() {
  const { t } = useTranslation();
  const [username, setUsername] = createSignal('');
  const [password, setPassword] = createSignal('');

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    
    if (!username().trim() || !password().trim()) {
      gameStore.setNotification({
        type: 'error',
        message: t('validation.usernameRequired')
      });
      return;
    }

    try {
      await gameStore.adminLogin(username(), password());
    } catch (error) {
      // Error handling is done in the store
    }
  };

  return (
    <div class="admin-login">
      <div class="admin-login-container">
        <div class="admin-login-header">
          <h1>🛡️ {t('adminLogin.title')}</h1>
          <p>{t('adminLogin.subtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} class="admin-login-form">
          <div class="form-group">
            <label for="username">{t('adminLogin.username')}</label>
            <input
              id="username"
              type="text"
              value={username()}
              onInput={(e) => setUsername(e.currentTarget.value)}
              placeholder={t('adminLogin.usernamePlaceholder')}
              disabled={gameStore.loadingState.login}
              required
            />
          </div>

          <div class="form-group">
            <label for="password">{t('adminLogin.password')}</label>
            <input
              id="password"
              type="password"
              value={password()}
              onInput={(e) => setPassword(e.currentTarget.value)}
              placeholder={t('adminLogin.passwordPlaceholder')}
              disabled={gameStore.loadingState.login}
              required
            />
          </div>

          <button
            type="submit"
            class="admin-login-btn"
            disabled={gameStore.loadingState.login}
          >
            {gameStore.loadingState.login ? t('adminLogin.loggingIn') : t('adminLogin.login')}
          </button>
        </form>

        <div class="admin-login-footer">
          <p>
            <a href="/">← {t('adminLogin.backToGame')}</a>
          </p>
        </div>
      </div>
    </div>
  );
}